export default __webpack_public_path__ + "static/media/a_wdt_c_4.c6fd1665.mp3";